module.exports = __webpack_public_path__ + "img/address_img.65e604ee.svg";